import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginEmail: '',
			loginPassword: '',
			loginRemember: false,
			loginResponse: '',
			isLoading: false,
			token: '',
			showPreloader: false,
			isLogged: false
		}
	}

	onSubmitLogin = (event) => {
		var self = this;
		event.preventDefault();
		this.setState({
			isLoading: true,
			showPreloader: true,
			loginResponse: ''
		}, function() {
			Api.loginUser(JSON.stringify({ email: this.state.loginEmail, password: this.state.loginPassword }), function(response) {
				self.setState({
					token: response.token,
					loginResponse: response.loginResponse,
					showPreloader: response.showPreloader,
				}, function() {
					if(response.errorCode === 0) {
						if(self.state.loginRemember === true) {
							localStorage.logged = true;
							localStorage.token = self.state.token;
						} else {
							sessionStorage.logged = true;
							sessionStorage.token = self.state.token;
						}
						setTimeout(function(){
							self.setState({
								isLogged: true
							});
						}, 2000);
					} else {
						self.setState({ isLoading: false });
					}
				});
			});
		});
	}

	onChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	onCheck = (event) => {
		var checkbox = event.target.name;
		this.setState({
			[event.target.name]: !this.state[checkbox]
		});
	}

    render() {
    	if(this.state.isLogged) {
			return window.location.replace('/');
    	} else{
    		return(
	            <div className="home">
	            	<div className="homeCtr br10 sh1 login">
	            		<h2 className="br10Top">Login</h2>
	            		<div className="info">
	            			<form onSubmit={this.onSubmitLogin} id="loginForm">
								<input type="text" name="loginEmail" maxLength="191" className="input1 br5 anim1" placeholder="E-mail address" onChange={this.onChange} />
								<input type="password" name="loginPassword" maxLength="191" className="input1 br5 anim1" placeholder="Password" onChange={this.onChange} />
								<div className="inputCtr1">
									<label><input type="checkbox" name="loginRemember" onChange={this.onCheck} /> Remember me</label>
								</div>
								<div className="row">
									<div className="col-6" style={{paddingRight: 10}}>
										<input type="submit" className="submit1 br5 anim1" value="Login" disabled={this.state.isLoading} />
									</div>
									<div className="col-6 ac" style={{paddingLeft: 10, paddingTop: 11}}>
										<Link to="/forgotpassword" className="link1">Forgot your password?</Link>
									</div>
								</div>
								<p className="response">{this.state.loginResponse}</p>
								<img className="preloader" src={Preloader} alt="Fresenius Preloader" style={{display: (this.state.showPreloader ? 'block' : 'none')}} />
							</form>
	            		</div>
	            	</div>
	            </div>
	        );
    	}
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js